import React, { useState } from "react";
import "./ContactModal.css";

const ContactModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    companyEmail: "contact@nest-ia.com",
    email: "",
    subject: "",
    message: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Create email content
    const subject = encodeURIComponent(
      formData.subject || "Contact from Nestia Website"
    );
    const body = encodeURIComponent(`
Bonjour,

Vous avez reçu un nouveau message de contact depuis le site web de Nestia :

Nom/Email : ${formData.email}
Sujet : ${formData.subject}
Message : ${formData.message}

---
Ce message a été envoyé depuis le formulaire de contact du site web Nestia.
    `);

    // Create mailto link
    const mailtoLink = `mailto:contact@nest-ia.com?subject=${subject}&body=${body}`;

    // Open default email client
    window.open(mailtoLink, "_blank");

    // Close the modal
    onClose();
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="contact-modal-backdrop" onClick={handleBackdropClick}>
      <div className="contact-modal">
        <div className="contact-modal-header">
          <h2 className="contact-modal-title">Contact Us</h2>
          <p className="contact-modal-description">
            Prêt à transformer votre vision en réalité ? Notre équipe d'experts
            en branding, design UI/UX et développement est là pour concrétiser
            vos projets digitaux.
          </p>
          <button className="contact-modal-close" onClick={onClose}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        <div className="contact-modal-content">
          <div className="contact-form-section">
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="companyEmail" className="form-label">
                  Company Email
                </label>
                <input
                  type="email"
                  id="companyEmail"
                  name="companyEmail"
                  value={formData.companyEmail}
                  className="form-input disabled"
                  disabled
                />
              </div>

              <div className="form-group">
                <label htmlFor="email" className="form-label">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="form-input"
                  placeholder="Your email"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject" className="form-label">
                  Subject
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                  className="form-input"
                  placeholder="Subject"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="message" className="form-label">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  className="form-textarea"
                  placeholder="Your message"
                  rows="4"
                  required
                />
              </div>

              <button type="submit" className="contact-submit-btn">
                Send Message
              </button>
            </form>
          </div>

          <div className="contact-map-section">
            <div className="world-map">
              <div className="map-dots">
                <div
                  className="map-dot"
                  style={{ top: "20%", left: "30%" }}
                ></div>
                <div
                  className="map-dot"
                  style={{ top: "35%", left: "45%" }}
                ></div>
                <div
                  className="map-dot"
                  style={{ top: "50%", left: "25%" }}
                ></div>
                <div
                  className="map-dot"
                  style={{ top: "60%", left: "70%" }}
                ></div>
                <div
                  className="map-dot"
                  style={{ top: "75%", left: "55%" }}
                ></div>
              </div>
              <div className="map-flags">
                <div className="map-flag" style={{ top: "25%", left: "35%" }}>
                  <div className="flag-icon">🇩🇪</div>
                  <span className="flag-label">Germany</span>
                </div>
                <div className="map-flag" style={{ top: "70%", left: "75%" }}>
                  <div className="flag-icon">🇦🇺</div>
                  <span className="flag-label">Australia</span>
                </div>
                <div className="map-flag" style={{ top: "55%", left: "20%" }}>
                  <div className="flag-icon">🇧🇷</div>
                  <span className="flag-label">Brazil</span>
                </div>
                <div className="map-flag" style={{ top: "40%", left: "65%" }}>
                  <div className="flag-icon">🇵🇰</div>
                  <span className="flag-label">Pakistan</span>
                </div>
                <div className="map-flag" style={{ top: "30%", left: "15%" }}>
                  <div className="flag-icon">🇨🇦</div>
                  <span className="flag-label">Canada</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
